import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=a32b9746&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=js&"
export * from "./Faqs.vue?vue&type=script&lang=js&"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=a32b9746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b9746",
  null
  
)

export default component.exports